(function($){

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the blockname-block HTML.
     *
     * @date    15/4/19
     * @since   1.0.0
     *
     * @return  void
     */
    const _calculator = () => {

        /**
         * Number.prototype.format(n, x, s, c)
         *
         * @param integer n: length of decimal
         * @param integer x: length of whole part
         * @param mixed   s: sections delimiter
         * @param mixed   c: decimal delimiter
         */
        Number.prototype.formatNum = function (n, x, s, c) {
            var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
                num = this.toFixed(Math.max(0, ~~n));

            return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
        };

        /**
         * Set Structure
         *************************/
        var calc = {};
        calc.elm = {};
        calc.val = {};
        calc.fnc = {};

        calc.val.legal = 1.8;

        /**
         * Get Elements
         *************************/
        calc.elm.propValue = $('#propValue');
        calc.elm.propRent = $('#propRent');
        calc.elm.purchCost = $('#purchaserCost');
        calc.elm.grossValue = $('#grossValue');
        calc.elm.netYield = $('#netYield');
        calc.elm.yearPurch = $('#yearPurchase');
        calc.elm.btnReset = $('#btnReset');

        /**
         * Set Defaults
         *************************/
        calc.val.propValue = 0;
        calc.val.propRent = 0;
        calc.val.purchCost = 0;
        calc.val.legalFees = 0;
        calc.val.stampDuty = 0;
        calc.val.grossValue = 0;
        calc.val.netYield = 0;
        calc.val.yearPurch = 0;

        /**
         * Events
         *************************/
        calc.elm.propValue.on({
            change: function () {
                calc.val.propValue = parseFloat(calc.elm.propValue.val() || 0);
                calc.fnc.getCalculations();
            },

            keyup: function () {
                calc.val.propValue = parseFloat(calc.elm.propValue.val() || 0);
                calc.fnc.getCalculations();
            },

            blur: function () {
                calc.val.propValue = parseFloat(calc.elm.propValue.val() || 0);
                calc.fnc.getCalculations();
            }
        });

        calc.elm.propRent.on({
            change: function () {
                calc.val.propRent = parseFloat(calc.elm.propRent.val() || 0);
                calc.fnc.getCalculations();
            },

            keyup: function () {
                calc.val.propRent = parseFloat(calc.elm.propRent.val() || 0);
                calc.fnc.getCalculations();
            },

            blur: function () {
                calc.val.propRent = parseFloat(calc.elm.propRent.val() || 0);
                calc.fnc.getCalculations();
            }
        });

        calc.elm.btnReset.on({
            click: function () {
                calc.fnc.clearCalculations();
            },
        });

        /**
         * Functions
         *************************/

        calc.fnc.getCalculations = function () {
            calc.fnc.setPurchaseCost();
            calc.fnc.setGrossValue();
            calc.fnc.setNetYield();
            calc.fnc.setYearPurch();
        };

        calc.fnc.clearCalculations = function () {
            calc.val.propValue = 0;
            calc.val.propRent = 0;
            calc.val.purchCost = 0;
            calc.val.legalFees = 0;
            calc.val.stampDuty = 0;
            calc.val.grossValue = 0;
            calc.val.netYield = 0;
            calc.val.yearPurch = 0;

            calc.fnc.getCalculations();
        };


        calc.fnc.setPurchaseCost = function () {
            calc.fnc.setLegalFees();
            calc.fnc.setStampDuty();

            calc.val.purchCost = calc.val.legalFees + calc.val.stampDuty;

            var output = (calc.val.purchCost).formatNum(0);
            calc.elm.purchCost.html(output);
        };

        calc.fnc.setLegalFees = function () {
            calc.val.legalFees = 0;

            if (calc.val.propValue == 0) {
                calc.val.legalFees = 0;
            } else {
                calc.val.legalFees = parseFloat(calc.val.propValue * (calc.val.legal / 100));
            }

        };

        calc.fnc.setStampDuty = function () {
            var tempValue = calc.val.propValue;
            var tempDuty = 0;

            // 0% for the portion of the transaction value up to £150,000
            if (calc.val.propValue > 0 && calc.val.propValue <= 150000) {
                tempValue = tempValue - 150000;
                tempDuty = 0;
            }


            // 2% between £150,001 and £250,000
            if (calc.val.propValue > 150000) {

                if (calc.val.propValue > 250000) {
                    tempValue = 100000;
                } else {
                    tempValue = calc.val.propValue - 150000;
                }

                tempDuty = parseFloat(tempDuty + (tempValue * 0.02));
            }


            // 5% above £250,000.
            if (calc.val.propValue > 250000) {
                tempValue = parseFloat(calc.val.propValue - 250000);
                tempDuty = parseFloat(tempDuty + (tempValue * 0.05));
            }

            // Return compiled Duty
            calc.val.stampDuty = tempDuty;
        };

        calc.fnc.setGrossValue = function () {
            calc.val.grossValue = (calc.val.propValue + calc.val.purchCost);

            var output = (calc.val.grossValue).formatNum(0);
            calc.elm.grossValue.html(output);
        };

        calc.fnc.setNetYield = function () {
            if (calc.val.grossValue == 0) {
                calc.val.netYield = 0;
            } else {
                calc.val.netYield = parseFloat((calc.val.propRent / calc.val.grossValue) * 100);
            }

            var output = calc.val.netYield.formatNum(2);

            calc.elm.netYield.html(output);
        };

        calc.fnc.setYearPurch = function () {
            if (calc.val.propRent == 0) {
                calc.val.yearPurch = 0;
            } else {
                calc.val.yearPurch = parseFloat(calc.val.grossValue / calc.val.propRent);
            }

            var output = (calc.val.yearPurch).formatNum(2);

            calc.elm.yearPurch.html(output);
        };
    };
    var initializeBlock = function( $block ) {
        /**
         * Allows the investment calculator to be used.
         * This code has been taken from the old site
         */
        _calculator();

    }


    // Initialize each block on page load (front end).
    $(document).ready(function(){
        initializeBlock();
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=investment-calculator-block', initializeBlock );
    }

})(jQuery);